<mat-slider
    thumbLabel
    [step]="step"
    [min]="min"
    [max]="max"
    [disabled]="readOnly"
    [discrete]="showThumb"
>
    <input [formControl]="control" matSliderThumb />
</mat-slider>
